module.exports = __webpack_public_path__ + "static/images/finance-3.96deca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-3.png
// module id = KBRS
// module chunks = 8